<app-section
  titleSection="MENTIONS ET RÉSERVES"
  [isActivated]="notes.isEnabled"
  (enabled)="onEnabled($event)"
  (cancled)="onCancled()"
>
  <div read-mode class="px-3">
    <app-notes-read-mode [notes]="notes"> </app-notes-read-mode>
  </div>

  <div edit-mode>
    <app-notes-edit-mode
      [notes]="notes"
      (notesChanged)="onNotesChanged($event)"
    >
    </app-notes-edit-mode>
  </div>

  <div save-button>
    <p-button
      id="btn-valider-section"
      label="Valider"
      level="primary"
      title="Valider"
      [loading]="isLoading"
      [disabled]="isLoading"
      (click)="onSaveSection()"
    ></p-button>
  </div>
</app-section>
